var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStepOne(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 56,
    viewBox: "0 0 77 56",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "1iwpqdx2pa",
    d: "M0 0h33.802v33.802H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "lq6fmh6gwc",
    d: "M0 0h44.9v44.9H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.34 56c16.436 0 29.768-4.06 29.768-9.084 0-5.013-13.332-9.078-29.768-9.078-16.431 0-29.763 4.065-29.763 9.078C8.577 51.94 21.909 56 38.34 56",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.479 37.838H4.828a3.325 3.325 0 0 1-3.314-3.315V9.868a3.32 3.32 0 0 1 3.314-3.31h25.698a2.275 2.275 0 0 1 2.267 2.262v25.703a3.325 3.325 0 0 1-3.314 3.315",
    fill: "#F7D6BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.944 7.93a2.57 2.57 0 0 0-2.568 2.567v23.907a2.575 2.575 0 0 0 2.568 2.572h23.913a2.576 2.576 0 0 0 2.574-2.572V9.314c0-.762-.623-1.384-1.38-1.384H4.944zM28.857 39.35H4.944A4.953 4.953 0 0 1 0 34.404V10.497A4.957 4.957 0 0 1 4.944 5.55h25.107c2.07 0 3.75 1.69 3.75 3.765v25.089a4.947 4.947 0 0 1-4.944 4.947z",
    fill: "#AD591D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.361 37.838h-24.65a3.322 3.322 0 0 1-3.315-3.315V9.868a3.317 3.317 0 0 1 3.315-3.31h25.693a2.276 2.276 0 0 1 2.272 2.262v25.703a3.325 3.325 0 0 1-3.315 3.315",
    fill: "#F7D6BE"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(42.883 5.55)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "w9skko6m9b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#1iwpqdx2pa"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.948 2.38a2.57 2.57 0 0 0-2.567 2.567v23.907a2.574 2.574 0 0 0 2.567 2.573h23.907a2.575 2.575 0 0 0 2.573-2.573V3.765c0-.762-.623-1.385-1.38-1.385h-25.1zm23.907 31.422H4.948A4.954 4.954 0 0 1 0 28.854V4.947A4.957 4.957 0 0 1 4.948 0h25.1c2.07 0 3.755 1.69 3.755 3.765v25.09a4.954 4.954 0 0 1-4.948 4.947z",
    fill: "#AD591D",
    mask: "url(#w9skko6m9b)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M54.059 43.892H23.13c-3.28 0-5.977-2.691-5.977-5.977V6.986c0-3.29 2.697-5.977 5.977-5.977H54.06c3.291 0 5.977 2.686 5.977 5.977v30.929c0 3.286-2.686 5.977-5.977 5.977",
    fill: "#F3BB93"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.144)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ff2n6ii52d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lq6fmh6gwc"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.878 2.368a5.514 5.514 0 0 0-5.509 5.51v29.144a5.518 5.518 0 0 0 5.51 5.515h29.144a5.515 5.515 0 0 0 5.509-5.515V7.877a5.51 5.51 0 0 0-5.51-5.509H7.879zm29.145 42.533H7.878C3.533 44.9 0 41.368 0 37.022V7.877C0 3.532 3.533 0 7.878 0h29.145A7.883 7.883 0 0 1 44.9 7.877v29.145a7.883 7.883 0 0 1-7.878 7.879z",
    fill: "#AD591D",
    mask: "url(#ff2n6ii52d)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M50.668 37.838H26.017a3.325 3.325 0 0 1-3.314-3.315V9.868a3.32 3.32 0 0 1 3.314-3.31h25.699a2.275 2.275 0 0 1 2.266 2.262v25.703a3.325 3.325 0 0 1-3.314 3.315",
    fill: "#F7D6BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.703 26.924v7.18c0 2.055 1.708 3.734 3.8 3.734H49.44L29.831 19.17l-7.128 7.753zM49.503 14.126l-11.665 12.45 11.665 11.262h1.213a3.782 3.782 0 0 0 3.77-3.768V19.024l-4.983-4.898zM41.37 10.847a4.287 4.287 0 0 1-4.286 4.288 4.291 4.291 0 0 1-4.291-4.288 4.291 4.291 0 0 1 4.29-4.288 4.287 4.287 0 0 1 4.286 4.288",
    fill: "#ED995D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.12 34.408a2.573 2.573 0 0 1-2.568 2.568h-.732L39.393 26.898l9.981-10.669 3.746 3.683v14.496zm-26.477 2.568a2.579 2.579 0 0 1-2.579-2.568v-6.753L30 21.12l6.894 6.665c.005.005.01.01.016.01l9.493 9.18h-19.76zm0-29.046h6.038a5.367 5.367 0 0 0-.96 3.076 5.464 5.464 0 0 0 5.457 5.456 5.46 5.46 0 0 0 5.452-5.456 5.402 5.402 0 0 0-.954-3.076H51.74c.762 0 1.38.623 1.38 1.38v7.266l-2.942-2.888a1.161 1.161 0 0 0-.86-.343c-.317.005-.623.14-.841.379l-10.795 11.52-6.92-6.686a1.163 1.163 0 0 0-.867-.327 1.17 1.17 0 0 0-.835.384l-4.996 5.508V10.498a2.572 2.572 0 0 1 2.579-2.568zm13.617 3.076a3.088 3.088 0 0 1-3.082 3.08 3.088 3.088 0 0 1-3.081-3.08 3.084 3.084 0 0 1 3.081-3.076 3.084 3.084 0 0 1 3.082 3.076zM51.74 5.55H26.643a4.951 4.951 0 0 0-4.95 4.948v23.91a4.95 4.95 0 0 0 4.95 4.943h23.909a4.949 4.949 0 0 0 4.943-4.943V9.31c0-2.07-1.685-3.76-3.755-3.76z",
    fill: "#AD591D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.595 21.34 4.397-3.005c.722-.491 1.62.122 1.62 1.11v6.009c0 .988-.898 1.606-1.62 1.11l-4.397-3.01c-.721-.492-.721-1.723 0-2.214",
    fill: "#F7D6BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.95 22.046c-.056.057-.056.258 0 .31l4.303 2.925V19.115l-4.303 2.93zm4.38 5.702c-.423 0-.842-.13-1.22-.382L5.606 24.3c-.667-.45-1.065-1.239-1.065-2.106 0-.861.398-1.646 1.065-2.105l4.504-3.06a2.132 2.132 0 0 1 2.224-.129c.791.418 1.288 1.275 1.288 2.24v6.12c0 .96-.497 1.816-1.288 2.24-.32.164-.662.247-1.003.247z",
    fill: "#AD591D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m70.593 23.557-4.395 3.01c-.722.49-1.621-.127-1.621-1.11v-6.01c0-.992.899-1.605 1.621-1.109l4.395 3.005c.723.486.723 1.717 0 2.214",
    fill: "#F7D6BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.936 19.115V25.28l4.308-2.926c.052-.056.052-.258-.005-.314l-4.303-2.926zm-.077 8.633c-.342 0-.683-.083-1.004-.248-.791-.423-1.287-1.28-1.287-2.24v-6.12c0-.964.496-1.82 1.287-2.239a2.133 2.133 0 0 1 2.224.13l4.494 3.06c.677.458 1.076 1.243 1.076 2.104 0 .867-.399 1.657-1.076 2.106l-4.494 3.065a2.17 2.17 0 0 1-1.22.382z",
    fill: "#AD591D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepOne);
export default __webpack_public_path__ + "static/media/stepOne.c3ceec93c285947ab82f4d38588d0d4c.svg";
export { ForwardRef as ReactComponent };